import { render } from "./Ticketing.vue?vue&type=template&id=4cb795cc&scoped=true"
import script from "./Ticketing.vue?vue&type=script&lang=js"
export * from "./Ticketing.vue?vue&type=script&lang=js"

import "./Ticketing.vue?vue&type=style&index=0&id=4cb795cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb795cc"]])

export default __exports__